export const CurriculumTrainingItemGroupManagementConstants: Readonly<{
    curriculumTrainingItemGroupManagementHeaderText: string;
    curriculumTrainingItemGroupManagementConfirmationHeaderText:string;
    curriculumTrainingItemGroupManagementConfirmationMessageText:string;
  }> = {
    curriculumTrainingItemGroupManagementHeaderText : "Curriculum/Training Item Group Management",
    curriculumTrainingItemGroupManagementConfirmationHeaderText : "Confirmation",
    curriculumTrainingItemGroupManagementConfirmationMessageText : "Any unsaved changes will be lost. Do you want to continue?",
  };
